/* pmt-marquee v2 (NaturalSlim USA)
   Cambio vs v1: la animación ya no depende de @keyframes con var() ni se
   detiene con "Reducir movimiento" de iOS. Se anima con Web Animations API
   usando px concretos, lo que funciona igual en Safari/Chrome de iPhone. */
(function () {
  "use strict";
  if (customElements.get("pmt-marquee")) return;

  // No se usa [data-animate]: así la animación CSS con @keyframes + var() (la que
  // fallaba en iPhone) nunca se activa. Solo hace falta ocultar el desborde.
  var style = document.createElement("style");
  style.textContent =
    ".pmt-marquee[data-js-animate] .pmt-marquee__viewport{overflow:hidden!important;padding-inline:0!important}";
  document.head.appendChild(style);

  class PmtMarquee extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector(".pmt-marquee__viewport");
      this.track = this.querySelector(".pmt-marquee__track");
      this.group = this.querySelector(".pmt-marquee__group");
      this.toggle = this.querySelector(".pmt-marquee__toggle");
      if (!this.viewport || !this.track || !this.group) return;

      this.speed = Math.max(parseFloat(this.dataset.speed) || 60, 1);
      this.loopWidth = 0;
      this.animation = null;

      this.resizeObserver = new ResizeObserver(() => {
        window.requestAnimationFrame(() => this.update());
      });
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.group);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.update());
      window.addEventListener("load", () => this.update(), { once: true });

      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.toggleAttribute("data-offscreen", !entry.isIntersecting);
          this.syncPlayState();
        });
      });
      this.intersectionObserver.observe(this);

      // iOS puede dejar la animación congelada al volver de otra app/pestaña; reanudar al volver.
      this.onVisibility = () => this.syncPlayState();
      document.addEventListener("visibilitychange", this.onVisibility);
      this.onPageShow = () => this.update(true);
      window.addEventListener("pageshow", this.onPageShow);

      if (this.toggle) {
        this.onToggle = () => {
          const paused = this.toggleAttribute("data-user-paused");
          this.toggle.setAttribute("aria-pressed", paused ? "true" : "false");
          this.syncPlayState();
        };
        this.toggle.addEventListener("click", this.onToggle);
      }

      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      document.removeEventListener("visibilitychange", this.onVisibility);
      window.removeEventListener("pageshow", this.onPageShow);
      if (this.toggle && this.onToggle) this.toggle.removeEventListener("click", this.onToggle);
      if (this.animation) this.animation.cancel();
    }

    update(force) {
      if (this.dataset.enabled !== "true" || this.group.children.length === 0) {
        this.stop();
        return;
      }
      const groupWidth = this.group.getBoundingClientRect().width;
      const viewportWidth = this.viewport.getBoundingClientRect().width;
      if (groupWidth < 1 || viewportWidth < 1) return;

      const copiesNeeded = Math.max(Math.ceil(viewportWidth / groupWidth) + 1, 2);
      const currentCopies = this.track.querySelectorAll(".pmt-marquee__group").length;
      for (let i = currentCopies; i < copiesNeeded; i += 1) {
        const clone = this.group.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.querySelectorAll("a, button, [tabindex]").forEach((el) => el.setAttribute("tabindex", "-1"));
        this.track.appendChild(clone);
      }

      this.removeAttribute("data-animate");
      this.setAttribute("data-js-animate", "");
      if (this.toggle) this.toggle.hidden = false;

      if (!force && this.animation && Math.abs(groupWidth - this.loopWidth) < 0.5) {
        this.syncPlayState();
        return;
      }

      // Conservar la posición actual al recalcular (evita saltos al cargar fuentes).
      const progress = this.animation && this.animation.effect
        ? (this.animation.effect.getComputedTiming().progress || 0)
        : 0;
      if (this.animation) this.animation.cancel();

      this.loopWidth = groupWidth;
      const duration = (groupWidth / this.speed) * 1000;
      this.animation = this.track.animate(
        [
          { transform: "translate3d(0, 0, 0)" },
          { transform: "translate3d(" + -groupWidth + "px, 0, 0)" },
        ],
        {
          duration: duration,
          iterations: Infinity,
          easing: "linear",
          direction: this.dataset.direction === "right" ? "reverse" : "normal",
        }
      );
      this.animation.currentTime = progress * duration;
      this.syncPlayState();
    }

    syncPlayState() {
      if (!this.animation) return;
      if (this.hasAttribute("data-user-paused")) {
        this.animation.pause();
      } else if (this.animation.playState !== "running") {
        this.animation.play();
      }
    }

    stop() {
      if (this.animation) {
        this.animation.cancel();
        this.animation = null;
      }
      this.loopWidth = 0;
      this.removeAttribute("data-animate");
      this.removeAttribute("data-js-animate");
      this.track.querySelectorAll('.pmt-marquee__group[aria-hidden="true"]').forEach((clone) => clone.remove());
      if (this.toggle) this.toggle.hidden = true;
    }
  }

  customElements.define("pmt-marquee", PmtMarquee);
})();
